<!-- 注册 -->
<template>
    <div class="register">
        <div class="reg-decor" aria-hidden="true">
            <span class="reg-decor__blob reg-decor__blob--a"></span>
            <span class="reg-decor__blob reg-decor__blob--b"></span>
            <span class="reg-decor__grain"></span>
        </div>
        <div class="navbar themeBg"></div>
        <div class="main">
            <div class="cont">
                <div class="contHeader">
                    <p class="contKicker">新用户</p>
                    <div class="contTitle">注册</div>
                    <p class="contSub">填写信息以完成开户</p>
                </div>
                <div class="contBody">
                    <div class="item">
                        <van-field
                            v-model="phone"
                            type="tel"
                            @update:model-value="phoneChange"
                            placeholder="请输入您的手机号"
                            clearable
                        >
                            <template #label>
                                <img class="labelIcon" src="@/assets/register/phoneIcon.png" alt="">
                            </template>
                        </van-field>
                    </div>
                    <div class="codeWrap item marginBtm15">
                        <div class="codeField">
                            <van-field
                                v-model="authCode"
                                label="验证码"
                                maxlength="6"
                                type="number"
                                placeholder="请输入验证码"
                                clearable
                            >
                                <template #label>
                                    <img class="labelIcon" src="@/assets/register/codeIcon.png" alt="">
                                </template>
                            </van-field>
                        </div>
                        <div class="codeWrapRight" @click="getCode">
                            {{num == 60 ? '获取验证码' : `${num}后获取`}}
                        </div>
                    </div>
                    <div class="item marginBtm15">
                        <van-field
                            v-model="password"
                            label="密码"
                            :type="showPassword ? 'text' : 'password'"
                            placeholder="6-16位由字母、数字组合的登录密码"
                            clearable
                        >
                            <template #right-icon>
                                <van-icon v-if="showPassword" name="eye-o" @click="setShowPassword"/>
                                <van-icon v-else name="closed-eye" @click="setShowPassword"/>
                            </template>
                            <template #label>
                                <img class="labelIcon" src="@/assets/register/passwordIcon.png" alt="">
                            </template>
                        </van-field>
                    </div>
                    <!-- <div class="item">
                        <van-field
                            label="省市区"
                            type="tel"
                            v-model="provinceDesc"
                            readonly
                            @click="show=true"
                            placeholder="请选择省市区"
                            isLink
                            clearable
                        >
                            <template #label>
                                <img class="labelIcon" src="@/assets/register/passwordIcon.png" alt="">
                            </template>
                        </van-field>
                    </div> -->
                    <div class="item marginBtm15 invite-item">
                        <van-field
                            v-model="parentUserPhoneValue"
                            disabled
                            label="邀请人"
                            placeholder="请输入邀请人手机号"
                            clearable
                        >
                            <template #label>
                                <img class="labelIcon" src="@/assets/register/parentIcon.png" alt="">
                            </template>
                        </van-field>
                    </div>
                    <div class="submit">
                        <van-button :disabled="userExist" color="#0F766E" round block @click="registe">
                            立即注册
                        </van-button>
                    </div>
                </div>
            </div>
        </div>
        <footer class="reg-foot">
            <div @click="goDownload" class="goDownload">跳转下载APP</div>
            <div class="pull">
                <div class="pullLeft">
                    我已阅读并同意<span class="themeColor" @click.stop="goProtocolRge">《用户协议》</span>
                </div>
            </div>
        </footer>

        <!-- 选择省市区 -->
        <van-popup v-model:show="show" position="bottom">
            <van-area title="标题" :area-list="areaList" @confirm="cityConfirm" />
        </van-popup>

        <!-- 图形验证码 -->
        <Verify
        ref="verify"
        :captchaType="captchaType"
        :account="phone"
        :mode="mode"
        :img-size="{width:'300px',height:'140px'}"
        @success="handleSuccess"
        ></Verify>
    </div>
</template>

<script>
import { ref, reactive , getCurrentInstance, toRefs, onUnmounted } from 'vue';
import { Field , Icon , Button , Checkbox , NavBar , Area , Popup } from 'vant';
import storage from 'store';
import { ACCESS_TOKEN , BRANDID } from '@/utils/types';
import { validPsw } from '@/utils';
import areaLists from '@/assets/area.json';
import Verify from '@/components/verifition/Verify'
import { getCaptcha } from '@/api/brand';
export default {
    components:{
        [Field.name]:Field,
        [Icon.name]:Icon,
        [Button.name]:Button,
        [Checkbox.name]:Checkbox,
        [NavBar.name]:NavBar,
        [Area.name]:Area,
        [Popup.name]:Popup,
        Verify,
    },
    setup() {
        storage.clearAll();
        const { proxy } = getCurrentInstance();
        const phone = ref('');  // 手机号
        const authCode = ref(''); // 验证码
        const password = ref(''); // 登录密码
        const showPassword = ref(false)
        const repPassword = ref(''); // 确认登录密码
        const showRepPassword = ref(false)
        const payPassword = ref('')
        const showPayPassword = ref(false)
        const parentUserPhone = ref(proxy.getHashParam('phone')) // 推荐人手机号
        const parentUserPhoneValue = ref('');
        const province = ref('');
        const city = ref('');
        const area = ref('');
        const provinceDesc = ref('');
        if(parentUserPhone.value != ''){
            parentUserPhoneValue.value = proxy.hidePhone(parentUserPhone.value)
        }
        const brandId = proxy.getHashParam('brandId')
        const checked = ref(true); // 协议勾选状态
        const userExist = ref(false); // 用户是否注册
        const getCodeLoading = ref(false);
        const num = ref(60)
        const timer = ref(null)
        const verify = ref(null)
        const captchaType = ref('')
        const mode = ref('pop');
        const captchaId = proxy.captchaId;
        const phoneCodeType = ref('0');
        // 获取系统的token
        function getToken(){
            proxy.$http.brandApi.getToken(brandId)
            .then(res=>{
                if(res.success){
                    storage.set(ACCESS_TOKEN,res[ACCESS_TOKEN], res.expires_in)
                    getBrandConfig();
                }
            })
        }
        // 获取品牌配置
        const getBrandConfig = () => {
            proxy.$http.brandApi.getBrandConfig()
            .then(res => {
                if(res.success){
                    if(res.data.length > 0){
                        phoneCodeType.value = res.data[0]['phoneCodeType']
                    }
                }
            })
        }
        getToken()
        // 获取验证码
        function getCode () {
            console.log(phone.value)
            if(getCodeLoading.value == true){
                return;
            }
            if(phone.value == ''){
                proxy.$toast({position: 'bottom',message:'请输入手机号'})
                return
            }
            if(phone.value.length != 11){
                proxy.$toast({position: 'bottom',message:'请输入正确的手机号'})
                return
            }
            let typeIndex = Math.floor(Math.random() * 2);
            // var typeList = ['blockPuzzle','clickWord'];
            // var typeList = ['clickWord'];
            // captchaType.value = typeList[typeIndex];

            // captchaType.value = 'blockPuzzle';
            // proxy.$refs.verify.show();

            // start();
            if(phoneCodeType.value == '0'){
                getCodeApi();
            }else if(phoneCodeType.value == '1'){
                start();
            }else{
                createNEG();
            }
        }
        const handleSuccess = (res)=>{
            console.log(res);
            getCodeApi();
        }
        // 验证接口
        function getCodeApi (){
            getCodeLoading.value = true
            num.value--;
            timer.value = setInterval(()=>{
                num.value--;
                console.log(num.value,'num')
                if(num.value == 0){
                    getCodeLoading.value = false
                    clearInterval(timer.value)
                    num.value = 60;
                }
            },1000)
            proxy.$http.loginApi.getCode(phone.value)
            .then(res=>{
                console.log(res,'res')
                if(res.success){
                    proxy.$toast({position: 'bottom',message:'验证码获取成功'})
                }else{
                    proxy.$toast({position: 'bottom',message:res.errMessage})
                }
            })
        }
        // 注册
        function registe () {
            if(phone.value == ''){
                proxy.$toast({position: 'bottom',message:'请输入手机号'})
                return
            }
            if(phone.value.length != 11){
                proxy.$toast({position: 'bottom',message:'请输入正确的手机号'})
                return
            }
            if(authCode.value == ''){
                proxy.$toast({position: 'bottom',message:'请输入验证码'})
                return
            }
            if(password.value == ''){
                proxy.$toast({position: 'bottom',message:'请输入登录密码'})
                return
            }
            // if(password.value.length < 6 || password.value.length > 16 || !validPsw(password.value)){
            //     proxy.$toast({position: 'bottom',message:'登录密码由6-16位由字母、数字组合！'})
            //     return
            // }
            if(password.value.length < 6 || password.value.length > 16){
                proxy.$toast({position: 'bottom',message:'登录密码由6-16位由字母、数字组合！'})
                return
            }
            if(payPassword.value == '123456'){
                proxy.$toast({position: 'bottom',message: '支付密码不能太过简单'})
                return;
            }
            // if(province.value == ''){
            //     proxy.$toast({position: 'bottom',message: '请选择省市区'})
            //     return;
            // }
            proxy.$http.loginApi.register(phone.value,authCode.value,password.value,parentUserPhone.value)
            .then(res=>{
                if(res.success){
                    storage.set(ACCESS_TOKEN,res[ACCESS_TOKEN], res.expires_in);
                    updateUser();
                    // proxy.$toast({position: 'bottom',message:'注册成功，正在跳转下载页面！'})
                    // userExist.value = true
                    // setTimeout(()=>{
                    //     goDownload()
                    // },1000)
                }else{
                    proxy.$toast({position: 'bottom',message:res.errMessage})
                }
            })
        }

        // 修改用户信息
        function updateUser (){
            proxy.$http.userApi.updateUser({province: province.value,city: city.value,country: area.value})
            .then(res=>{
                if(res.success){
                    goNext();
                }else{
                    proxy.$toast({position: 'bottom',message:res.errMessage})
                }
            })
        }

        // 跳转
        const goNext = () => {
            proxy.$toast({position: 'bottom',message:'注册成功，正在跳转下载页面！'})
                    userExist.value = true
                    setTimeout(()=>{
                        goDownload()
                    },1000)
        }

        function setShowPassword(){
            console.log(showPassword)
            showPassword.value = !showPassword.value
        }
        function setRepShowPassword(){
            showRepPassword.value = !showRepPassword.value
        }
        function setPayShowPassword(){
            showPayPassword.value = !showPayPassword.value
        }
        // 跳转下载页面
        function goDownload(){
            if(userExist.value){
                storage.set(BRANDID , brandId)
                proxy.$router.push({name: 'download',params:{'brandId':brandId}})
            }else{
                if(phone.value == ''){
                    proxy.$toast({message:'请输入手机号!',position: 'bottom'})
                }else{
                    proxy.$toast({message:'当前手机号还未注册，请先注册!',position: 'bottom'})
                }
            }
        }
        // 判断用户是否注册
        function phoneChange(val){
            console.log(val)
            if(val.length == 11){
                proxy.$http.loginApi.userIsExist(val)
                .then(res=>{
                    if(res.success){
                        userExist.value = true
                        proxy.$toast({message:'当前手机号已注册，请点击下载app，直接前往下载页面!',position: 'bottom'})
                    }else{
                        userExist.value = false
                    }
                })
            }
        }
        // 跳转注册协议
        function goProtocolRge(){
            proxy.$router.push({name: 'agreement'})
        }
        // 销毁的时候注销定时器
        onUnmounted(()=>{
            console.log('销毁定时器')
            if(timer.value){
                clearInterval(timer.value)
            }
        })

        // 查询省市区
        const show = ref(false);
        const areaList = ref(areaLists);
        // console.log(areaLists,'areaLists')
        // 确认选择省市区
        const cityConfirm = (val) => {
            console.log(val,'val')
            if(val.length == 3){
                province.value = val[0].name;
                city.value = val[1].name;
                area.value = val[2].name;
                provinceDesc.value = val[0].name + '/' + val[1].name + '/' + val[2].name;
            }else{
                province.value = '';
                city.value = '';
                area.value = '';
                provinceDesc.value = '';
            }
            show.value = false;
        }

        // 开始验证
        const start = () => {
            try {
                // 生成一个验证码对象
                // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
                //callback：定义的回调函数
                var captcha = new TencentCaptcha(captchaId, callback, {
                    userLanguage: 'zh-cn',
                    showFn: (ret) => {
                        const {
                        duration, // 验证码渲染完成的耗时(ms)
                        sid, // 链路sid
                        } = ret;
                    },
                });
                console.log(captcha,'TencentCaptcha')
                // 调用方法，显示验证码
                captcha.show();
            } catch (error) {
                console.log(error,'error')
                // 加载异常，调用验证码js加载错误处理函数
                loadErrorCallback();
            }
        }

        // 定义验证码js加载错误处理函数
        const loadErrorCallback = () => {
            var appid = captchaId;
            // 生成容灾票据或自行做其它处理
            var ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
            callback({
                ret: 1,
                randstr: '@' + Math.random().toString(36).substr(2),
                ticket: ticket,
                errorCode: 1001,
                errorMessage: 'jsload_error'
            });
        }

        // 验证码验证回调
        const callback = (res) => {
            // 第一个参数传入回调结果，结果如下：
            // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
            // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
            // CaptchaAppId       String    验证码应用ID。
            // bizState    Any       自定义透传参数。
            // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。
            // verifyDuration     Int   验证码校验接口耗时（ms）。
            // actionDuration     Int   操作校验成功耗时（用户动作+校验完成）(ms)。
            // sid     String   链路sid。
        ﻿
        ﻿
        ﻿
            // res（用户主动关闭验证码）= {ret: 2, ticket: null}
            // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
            // res（请求验证码发生错误，验证码自动返回trerror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
            // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
            if (res.ret === 0) {
                proxy.$http.loginApi.checkTYCaptcha({account: phone.value,ticket: res.ticket,randstr: res.randstr})
                .then(res=>{
                    if(res.success){
                        getCodeApi();
                    }else{
                        proxy.$toast({message: res.errMessage ?? '验证失败' ,position: 'bottom'})
                    }
                })
            }else{
                proxy.$toast({message: res.errorMessage ?? '验证失败' ,position: 'bottom'})
            }
        }
        // 易盾验证
        const createNEG = () => {
            try {
                const neg = createNEGuardian({ productId: 'YD00153684635208', timeout: 6000 })

                neg.getToken().then(result => {
                    if (result.code === 200) { // 正常情况
                        // var res = {
                        //     ret: 0,
                        //     token: result.token,
                        // }
                        // captcha.postMessage(JSON.stringify(res))
                        proxy.$http.loginApi.riskCheck({account: phone.value,token: result.token})
                        .then(res=>{
                            if(res.success){
                                getCodeApi();
                            }else{
                                proxy.$toast({message: res.errMessage ?? '验证失败' ,position: 'bottom'})
                            }
                        })
                    }else if (result.code === 201) { // 离线模式
                        proxy.$http.loginApi.riskCheck({account: phone.value,token: result.token})
                        .then(res=>{
                            if(res.success){
                                getCodeApi();
                            }else{
                                proxy.$toast({message: res.errMessage ?? '验证失败' ,position: 'bottom'})
                            }
                        })
                    }else{
                        proxy.$toast({message: res.errorMessage ?? '验证失败' ,position: 'bottom'})
                        getCodeLoading.value = false
                    }
                })
            } catch (error) {
                console.log(error,'error')
                // 加载异常，调用验证码js加载错误处理函数
                loadErrorCallback();
                getCodeLoading.value = false
            }
        }

        return {
            phone,
            authCode,
            password,
            repPassword,
            parentUserPhone,
            checked,
            getCode,
            registe,
            showPassword,
            setShowPassword,
            showRepPassword,
            setRepShowPassword,
            goDownload,
            phoneChange,
            userExist,
            goProtocolRge,
            getCodeLoading,
            num,
            showPayPassword,
            payPassword,
            setPayShowPassword,
            parentUserPhoneValue,
            show,
            areaList,
            cityConfirm,
            province,
            city,
            area,
            provinceDesc,
            verify,
            handleSuccess,
            captchaType,
            mode,
        }
    }
}

</script>
<style scoped>
/* 暖纸色 + 青绿点缀：与原先深色玻璃/霓虹绿彻底区分 */
.register{
    --reg-ink: #1c1917;
    --reg-muted: #57534e;
    --reg-line: #d6d3d1;
    --reg-paper: #fffefb;
    --reg-wash: #f5f0e8;
    --reg-teal: #0f766e;
    --reg-teal-dim: rgba(15, 118, 110, 0.12);
    --reg-amber: #d97706;
    --yl-accent: var(--reg-teal);
    min-height: 100vh;
    background:
        linear-gradient(165deg, #fdf8f3 0%, #e8f2f0 42%, #f0ebe3 100%);
    display: flex;
    flex-direction: column;
    padding: 18px 16px 24px;
    box-sizing: border-box;
    align-items: stretch;
    font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
    position: relative;
    overflow-x: hidden;
}
.reg-decor{
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    overflow: hidden;
}
.reg-decor__blob{
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.45;
}
.reg-decor__blob--a{
    width: 280px;
    height: 280px;
    top: -120px;
    right: -80px;
    background: #99f6e4;
}
.reg-decor__blob--b{
    width: 220px;
    height: 220px;
    bottom: 8%;
    left: -100px;
    background: #fde68a;
}
.reg-decor__grain{
    position: absolute;
    inset: 0;
    opacity: 0.04;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
}
/* 顶栏：覆盖全局 themeBg 橙色，改为留白装饰条 */
.register .navbar.themeBg{
    height: 8px;
    min-height: 8px;
    background: linear-gradient(90deg, var(--reg-teal) 0%, var(--reg-amber) 100%) !important;
    border-radius: 999px;
    margin: 0 8px 20px;
    box-shadow: 0 2px 0 rgba(28, 25, 23, 0.06);
}
.main{
    flex: 1;
    margin: 0 auto 20px;
    width: 100%;
    max-width: 440px;
    background: var(--reg-paper);
    border-radius: 4px 24px 20px 4px;
    padding: 26px 20px 28px;
    border: 1px solid rgba(28, 25, 23, 0.08);
    box-shadow:
        12px 12px 0 rgba(15, 118, 110, 0.12),
        0 24px 48px rgba(28, 25, 23, 0.08);
    position: relative;
    z-index: 1;
    box-sizing: border-box;
}
.main::before{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    background: linear-gradient(180deg, var(--reg-teal), var(--reg-amber));
    border-radius: 4px 0 0 4px;
}
.contHeader{
    position: relative;
    z-index: 1;
    padding-left: 4px;
    margin-bottom: 22px;
}
.contKicker{
    font-size: 11px;
    letter-spacing: 0.35em;
    text-transform: uppercase;
    color: var(--reg-teal);
    margin: 0 0 6px;
    font-weight: 600;
}
.contTitle{
    margin: 0;
    font-family: "Noto Serif SC", "Songti SC", Georgia, "Times New Roman", serif;
    font-size: 28px;
    font-weight: 700;
    color: var(--reg-ink);
    letter-spacing: 0.06em;
    line-height: 1.2;
}
.contTitle::after{
    display: none;
}
.contSub{
    margin: 10px 0 0;
    font-size: 13px;
    color: var(--reg-muted);
    line-height: 1.5;
}
.item{
    height: auto;
    margin-bottom: 14px;
    position: relative;
    z-index: 1;
}
.item >>> .van-field{
    flex: 1;
    min-height: 48px;
    background: var(--reg-wash);
    border-radius: 2px 14px 2px 14px;
    box-shadow: inset 0 0 0 1px rgba(28, 25, 23, 0.07);
    transition: box-shadow 180ms ease, background-color 180ms ease;
}
.item:focus-within >>> .van-field{
    background: #fff;
    box-shadow:
        inset 0 0 0 2px var(--reg-teal),
        0 8px 20px var(--reg-teal-dim);
}
.item >>> .van-cell{
    background: transparent;
    padding-top: 10px;
    padding-bottom: 10px;
}
.item >>> .van-field__label{
    font-size: 13px;
    color: var(--reg-muted);
    font-weight: 600;
    width: 36px;
}
.labelIcon{
    width: 22px;
    height: 22px;
    opacity: 0.88;
    filter: none;
}
.item >>> .van-field__control{
    font-size: 15px;
    color: var(--reg-ink);
}
.item >>> .van-field__control::placeholder{
    color: #a8a29e;
}
.item >>> .van-field--disabled{
    opacity: 1;
}
.item >>> .van-field--disabled .van-field__control{
    color: #78716c;
}
.item.invite-item >>> .van-field{
    background: #f5f5f4;
    box-shadow: inset 0 0 0 1px dashed rgba(28, 25, 23, 0.12);
}
.codeWrap{
    display: flex;
    align-items: stretch;
    gap: 10px;
}
.codeField{
    flex: 1;
    min-width: 0;
}
.codeWrapRight{
    width: 108px;
    flex-shrink: 0;
    border-radius: 2px 14px 2px 14px;
    border: 2px solid var(--reg-teal);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--reg-teal);
    font-size: 12px;
    font-weight: 600;
    padding: 0 8px;
    background: #fff;
    cursor: pointer;
    user-select: none;
    transition: background-color 180ms ease, color 180ms ease, transform 180ms ease;
}
.codeWrapRight:active{
    transform: scale(0.98);
}
.codeWrapRight[disabled]{
    color: #a8a29e;
    border-color: #d6d3d1;
}
.reg-foot{
    width: 100%;
    max-width: 440px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    z-index: 1;
}
.goDownload{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 12px;
    color: var(--reg-amber);
    padding: 10px 22px;
    border-radius: 2px 16px 2px 16px;
    border: 2px dashed rgba(217, 119, 6, 0.45);
    background: rgba(254, 243, 199, 0.35);
    cursor: pointer;
    user-select: none;
    transition: background-color 180ms ease, transform 180ms ease;
}
.goDownload:active{
    transform: scale(0.99);
}
.submit{
    margin: 20px 2px 0;
    display: flex;
    position: relative;
    z-index: 1;
}
.submit .van-button{
    height: 50px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.12em;
    border-radius: 2px 999px 2px 999px !important;
    border: none;
    box-shadow: 0 4px 0 #115e59;
    transition: transform 180ms ease, box-shadow 180ms ease;
}
.submit .van-button:deep(.van-button__text){
    line-height: 1;
}
.submit .van-button:active{
    transform: translateY(2px);
    box-shadow: 0 1px 0 #115e59;
}
.pull{
    margin-bottom: 8px;
    text-align: center;
    color: var(--reg-muted);
    margin-top: 0;
    font-size: 12px;
    line-height: 1.7;
}
.pull .themeColor{
    color: var(--reg-teal);
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
}

@media (prefers-reduced-motion: reduce){
    .item >>> .van-field,
    .codeWrapRight,
    .goDownload,
    .submit .van-button{
        transition: none !important;
    }
}
</style>